import { Component, OnInit } from '@angular/core';
import { TrackingService } from  './service/tracking.service';

declare let Tawk_API;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})


export class AppComponent implements OnInit  {

  constructor(private trackingService: TrackingService) {
  }


  ngOnInit() {
    Tawk_API = Tawk_API || {};
    Tawk_API.onChatMaximized = () => {
      this.trackingService.chatOpened();
    };
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/app.component.ts